export default __webpack_public_path__ + "static/media/images.a5a4041b.jpg";